<script lang="ts">
    import {getContext} from 'svelte';
    import type {Readable} from 'svelte/store';
    import type {InputDescription} from './types';

    /*
    headless-ui does not allow using custom ids for its elements,
    and it manages aria-describedby attributes, preventing us doing it manually.
    it also does not allow for custom description to be outside its container component
    to provide correct description information for main inputs build with headless-ui,
    we need to tap its internal API via svelte context.
    basically this component acts as headless-ui description component,
    but instead of rendering description it registers id of our existing description element
    * */

    export let inputDescription: InputDescription;

    const DESCRIPTION_CONTEXT_NAME = 'headlessui-description-context';
    const contextStore: Readable<any> = getContext(DESCRIPTION_CONTEXT_NAME)

    if (!!inputDescription) {
        $contextStore?.register(inputDescription.id);
    }
</script>
